/// <amd-module name="Widgets/MarkdownWidget/VersionControlDataProvider" />
import { getProject, getRepoType, RepositoryType } from "Tfs/Widget/Context";
import * as Git from "VC/Common/Contracts/Git";
import { getGitClient, IGitRestClient } from "VC/Common/RestClient/Git";
import { getTfvcClient, ITfvcRestClient } from "VC/Common/RestClient/Tfvc";
import { IVssPageContext } from "VSS/Platform/Context";

export interface VCPathInformation {
    path: string;
    repositoryId: string;
    version: string;
}

export class VersionControlFileContentDataProvider {
    constructor(private context: IVssPageContext) {}

    public getFile(pathInfo: VCPathInformation): Promise<Git.ItemModel | undefined> {
        const repoType = getRepoType(pathInfo.path);
        const project = getProject(this.context);
        let file: Promise<Git.ItemModel | undefined> = Promise.resolve(undefined);

        if (repoType == RepositoryType.Git) {
            const gitClient: IGitRestClient = getGitClient(this.context);

            const itemVersion: Git.GitVersionDescriptor = {
                version: VersionControlFileContentDataProvider.getBranchNameWithoutPrefix(pathInfo),
                versionOptions: Git.GitVersionOptions.None,
                versionType: Git.GitVersionType.Branch
            };

            file = gitClient.getItem(
                pathInfo.repositoryId,
                pathInfo.path,
                project.id,
                undefined,
                undefined,
                undefined,
                undefined,
                false,
                itemVersion,
                true,
                false
            );
        } else {
            const tfvcClient: ITfvcRestClient = getTfvcClient(this.context);

            file = tfvcClient.getItem(pathInfo.path, project.id, undefined, undefined, undefined, undefined, undefined, true);
        }

        return file;
    }

    public static getBranchNameWithoutPrefix(pathInfo: VCPathInformation): string {
        if (pathInfo && pathInfo.version && pathInfo.version.startsWith("GB")) {
            return pathInfo.version.substring(2);
        }
        return pathInfo.version;
    }
}
